



















import Vue from 'vue'
import ButtonEl from '@/components/elements/ButtonEl.vue'
import { LiteButtonElInterface } from '@/config/interfaces'

export default Vue.extend({
  name: 'LiteButtonEl',

  components: { ButtonEl },
  props: {
    templateItemData: {
      type: Object as () => LiteButtonElInterface,
      required: true
    }
  }
})
